<template>
  <v-dialog width="500" v-model="showCityForm">
    <v-card>
      <v-card-title class="secondary white--text">
        <span class="text-capitalize">
          {{ editMode ? "Update" : "Add" }} City
        </span>

        <v-spacer></v-spacer>

        <v-btn icon @click="resetForm(), (showCityForm = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-form ref="cityForm" v-if="showCityForm" v-model="isValid">
          <v-row class="my-0">
            <v-col cols="12" class="Form-Columns">
              <InputField
                type="text"
                label="City Name *"
                required
                :rules="[
                  (val) => !!val || 'City Name is required!',
                  (val) =>
                    $globals.lettersOnlyRegExp.test(val) ||
                    'Invalid City Name!',
                ]"
                hide-details="auto"
                v-model="cityDetails.city_name"
                :error-messages="formErrors.city_name"
                @input="delete formErrors.city_name"
              />
            </v-col>

            <v-col cols="12" class="Form-Columns">
              <InputField
                type="text"
                label="City Code *"
                required
                :rules="[(val) => !!val || 'City Code is required!']"
                hide-details="auto"
                v-model="cityDetails.city_code"
                :error-messages="formErrors.city_code"
                @input="delete formErrors.city_code"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid"
          @click="submitForm"
        >
          Submit
        </v-btn>

        <v-btn
          class="ml-3"
          color="secondary"
          v-if="!editMode"
          depressed
          @click="resetForm"
        >
          Reset
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import SelectField from "@/components/FormBaseComponents/SelectField.vue";

export default {
  components: {
    InputField,
    SelectField,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editCityID: {
      type: [Number, null],
      default: null,
    },
    countryId: {
      type: [Number, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editMode) {
          this.getCityObject(this.editCityID);
        }
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showCityForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      formErrors: {},
      isValid: true,
      isTextInput: false,

      cityDetails: {},
    };
  },
  methods: {
    submitForm() {
      this.$bus.$emit("showLoader", true);
      if (!this.editMode) {
        this.cityDetails = {
          ...this.cityDetails,
          country: this.countryId,
        };
        this.$api.city
          .addCity(this.cityDetails)
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "City added successfully!",
              color: "success",
            });
            this.resetForm();
            this.showCityForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't add city!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      } else {
        this.$api.city
          .updateCity({ id: this.cityDetails.id, data: this.cityDetails })
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "City updated successfully!",
              color: "success",
            });
            this.resetForm();
            this.showCityForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't update city!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      }
    },

    resetForm() {
      if (this.$refs.cityForm) {
        this.$refs.cityForm.reset();
      }
      this.cityDetails = {};
    },

    getCityObject(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.city
        .getCityObject(id)
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.cityDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
